import {
  useIsMapsClient,
  useIsMapsRegionalMimicClient,
  useMapsAgentMimicClient
} from 'store/features/auth';

export const useShowFavouriteBrands = () => {
  const isMapsClient = useIsMapsClient();
  const isMapsRegionalMimicClient = useIsMapsRegionalMimicClient();
  const isMapsAgentMimicClient = useMapsAgentMimicClient();

  return isMapsClient || isMapsRegionalMimicClient || isMapsAgentMimicClient;
};
